import { store } from '@/store'
/*
 * vendor
 */
import VueBarcode from '@chenfengyuan/vue-barcode'
import { createHead } from '@unhead/vue/client'
import VueTouchEvents from 'vue3-touch-events'
import VueTour from 'vue3-tour'
import VueDOMPurifyHTML from 'vue-dompurify-html'

/*
 * our
 */
import Mapkit from './mapkit.js'
import Flash from './flash.js'
import Facebook from './facebook.js'
import e2eUtils from './e2e-utils'
import Datadog from './datadog/index.js'

export function registerPlugins ({ app, router }) {
  app.use(VueTouchEvents, {
    disableClick: true,
  })

  app.use(Datadog)

  app.component('vue-barcode', VueBarcode)

  app.use(Flash)

  app.use(Mapkit, store)

  app.use(VueTour)

  app.use(Facebook)

  app.use(e2eUtils)

  app.use(VueDOMPurifyHTML, {
    default: {
      ADD_ATTR: ['target'],
    },
  })

  const head = createHead()
  app.use(head)
}
